import React from "react";
import Similar from "./index";
import { IVideoDataSimilar } from "@/pages/VideoPage/interfaces";

interface SimilarVideoprops {
  isEven: boolean;
  languageHeadings: any;
  book: string;
  matchedTextQuestions: IVideoDataSimilar[];
  matchedQuestions: IVideoDataSimilar[];
  similarMathJax: string[];
  similarMathJaxText: string[];
}

const SimilarVideoPage = (props: SimilarVideoprops) => {
  const { languageHeadings } = props;
  const matchedPlaylist = props.matchedQuestions.filter((item) => item.type === "playlist");

  const matchedTextQuestions = props.matchedTextQuestions.slice(0, 3);
  const similarMathJaxText = props.similarMathJaxText.slice(0, 3);

  const remainingMatchedTextQuestions = props.matchedTextQuestions.slice(3).map((item) => {
    delete item.type;
    return item;
  });
  const remainingSimilarMathJaxText = props.similarMathJaxText.slice(3);


  const matchedQuestions = [...props.matchedQuestions.filter((item) => !item.type), ...remainingMatchedTextQuestions];
  const similarMathJax = [...props.similarMathJax, ...remainingSimilarMathJaxText];

  let matchedQuestionsSlot1: IVideoDataSimilar[] = matchedQuestions;
  let matchedQuestionsSlot2: IVideoDataSimilar[] = [];

  let similarMathJaxSlot1: string[] = similarMathJax;
  let similarMathJaxSlot2: string[] = [];

  const quizExists = props.matchedTextQuestions.length;
  if (quizExists) {
    matchedQuestionsSlot1 = matchedQuestions.slice(0, 2);
    matchedQuestionsSlot2 = matchedQuestions.slice(2);

    similarMathJaxSlot1 = similarMathJax.slice(0, 2);
    similarMathJaxSlot2 = similarMathJax.slice(2);
  }

  const extraProps: any = {};
  if (props.isEven) {
    extraProps.view = "CAROUSEL";
  }


  return (
    <>
      <Similar
        heading={languageHeadings["topperSolved"]}
        book={props.book}
        data={matchedPlaylist}
        similarMathJax={props.similarMathJax}
        {...extraProps}
      />
      <Similar
        id="similar-questions-1"
        heading={languageHeadings["similarQuestions"]}
        book={props.book}
        data={matchedQuestionsSlot1}
        similarMathJax={similarMathJaxSlot1}
        {...extraProps}
      />
      <Similar
        id="knowledge-check"
        heading={languageHeadings["knowledgeCheck"]}
        book={props.book}
        data={matchedTextQuestions}
        similarMathJax={similarMathJaxText}
        targetClass="knowledge-check"
        {...extraProps}
      />
      <Similar
        id="similar-questions-2"
        heading={""}
        book={props.book}
        data={matchedQuestionsSlot2}
        similarMathJax={similarMathJaxSlot2}
        {...extraProps}
      />
    </>
  )
}

export default SimilarVideoPage;